( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        require: {
            moment: {
                url: '//cdnjs.cloudflare.com/ajax/libs/moment.js/2.10.6/moment.min.js',
                fallback: '/files/templates/designs/wowpark/_assets/js/vendor/moment.min.js',
                callback: null
            },
            datepicker: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js',
                callback: null
            },
            datepicker_da: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/locales/bootstrap-datepicker.da.min.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/locales/bootstrap-datepicker.da.min.js',
                callback: null
            },
            datepicker_en: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/locales/bootstrap-datepicker.en-GB.min.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/locales/bootstrap-datepicker.en-GB.min.js',
                callback: null
            },
            datepicker_de: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/locales/bootstrap-datepicker.de.min.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/locales/bootstrap-datepicker.de.min.js',
                callback: null
            },
            moment: {
                url: '//cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/moment-with-locales.min.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/moment-with-locales.min.js',
                callback: null
            }
        }
    } );
}() );

